module.exports = __webpack_public_path__ + "static/img/top.7704ae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top.png
// module id = rOIf
// module chunks = 2